import { Injectable } from '@angular/core';
import { AgeGroup } from '../models';
import { DatabaseService } from './db-service';

@Injectable({
  providedIn: 'root'
})

export class AgeGroupService {

    public collection: string = 'ageGroups';
    private ageLevelList: AgeGroup[] = null;

    constructor(
        private databaseService: DatabaseService) {
    }

    public setAgeLevelList = (ageLevelList: AgeGroup[]): void => {
        this.ageLevelList = ageLevelList;
    } 

    public getAgeLevelList = (): AgeGroup[] => {
        return this.ageLevelList;
    }

    /**
     * Get Age Groups that are parent
     */
    public async getAgeGroups() {
        return this.databaseService
            .getDocuments(this.collection, ref => ref.where('isParent', '==', true)
        );
    }

    public getYearLevels() {
        return this.databaseService
            .getDocuments(this.collection, ref => ref.where('isParent', '==', false)
        );
    }
}
